import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';

/**
 * Validator Props
 */
@Component
class Props extends Mixins() {
}

export default Props;
